var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9976 9.42913H1.57079C1.49222 9.42913 1.42793 9.49342 1.42793 9.57199V10.6434C1.42793 10.722 1.49222 10.7863 1.57079 10.7863H12.3779L9.80115 14.0541C9.72793 14.147 9.794 14.2863 9.91365 14.2863H11.2083C11.2958 14.2863 11.3779 14.247 11.4333 14.1773L14.4476 10.3541C14.7422 9.97913 14.4761 9.42913 13.9976 9.42913ZM14.4279 5.21484H3.62079L6.19757 1.94699C6.27079 1.85413 6.20472 1.71484 6.08507 1.71484H4.79043C4.70293 1.71484 4.62079 1.75413 4.56543 1.82377L1.55114 5.64699C1.2565 6.02199 1.52257 6.57199 1.99936 6.57199H14.4279C14.5065 6.57199 14.5708 6.5077 14.5708 6.42913V5.3577C14.5708 5.27913 14.5065 5.21484 14.4279 5.21484Z",
    fill: "#354052"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap-icon.9f7d05df1080ee5f0340b04865398ebf.svg";
export { ForwardRef as ReactComponent };